/**
 * gift-card-recipient.js — Rooster Bus
 *
 * Replaces the previous version. Same disable/reveal behaviour, plus:
 *   - populates properties[__shopify_offset] with the buyer's timezone offset
 *     so a scheduled "Send on" date lands on the right local day
 *   - clamps the date input to <= 90 days out (Shopify's hard limit; submitting
 *     a later date fails validation with an unhelpful error)
 */
class GiftCardRecipient extends HTMLElement {
  constructor() {
    super();

    this.checkbox = this.querySelector('.gift-card-recipient__checkbox-input');
    this.fields = this.querySelectorAll('.gift-card-recipient__field-input');
    this.fieldset = this.querySelector('.gift-card-recipient__fieldset');
    this.sendOn = this.querySelector('.gift-card-recipient__send-on');
    this.offset = this.querySelector('#gift-card-recipient__offset');
  }

  connectedCallback() {
    this.disableFields();
    this.fieldset.style.maxHeight = '0px';

    if (this.offset) {
      this.offset.value = new Date().getTimezoneOffset();
    }

    this.checkbox?.addEventListener('change', this.activateFieldset.bind(this));
    this.sendOn?.addEventListener('change', this.clampSendOn.bind(this));
  }

  disableFields() {
    this.fields.forEach((field) => field.setAttribute('disabled', ''));
  }

  enableFields() {
    this.fields.forEach((field) => field.removeAttribute('disabled'));
  }

  activateFieldset() {
    if (this.checkbox.checked) {
      this.enableFields();
      this.fieldset.style.maxHeight = `${this.fieldset.scrollHeight}px`;
    } else {
      this.disableFields();
      this.fieldset.style.maxHeight = '0px';
    }
  }

  /**
   * Shopify rejects send dates more than 90 days out. Snap silently to the max
   * rather than letting the buyer hit a checkout error they can't interpret.
   */
  clampSendOn() {
    const max = this.dataset.sendOnMax;
    if (!max || !this.sendOn.value) return;
    if (this.sendOn.value > max) this.sendOn.value = max;

    const today = new Date().toISOString().slice(0, 10);
    if (this.sendOn.value < today) this.sendOn.value = today;
  }
}

customElements.define('gift-card-recipient', GiftCardRecipient);
